module.exports = __webpack_public_path__ + "ce4fcaee.png";